module.exports = __webpack_public_path__ + "img/clickshop.4c05e219.png";